import { jsx as _jsx } from "react/jsx-runtime";
//import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
function ThemedSuspense() {
    return (_jsx("div", { className: "w-full h-screen flex justify-center items-center text-center p-6", children: _jsx(CircularProgress, {}) }));
}
export default ThemedSuspense;
